export default {
  getImporterSchemas(state) {
    return state.importerSchemas;
  },
};
